module.exports = __webpack_public_path__ + "img/telegram.f0a97c93.png";